import apiClient from './client'

export interface MRFItem {
  id: number
  person_id: number
  event_title?: string
  event_description?: string
  event_location?: string
  event_date?: string
  notes?: string
  file_url?: string
  display_title: string
  form_filename: string
  mr_form_content_type?: string
  update_date?: string
}

export interface PaginatedMRF {
  items: MRFItem[]
  total: number
  page: number
  size: number
  pages: number
  has_next: boolean
  has_prev: boolean
}

export const mrfApi = {
  listByPerson: async (personId: number, page = 1, size = 20): Promise<PaginatedMRF> => {
    const { data } = await apiClient.get('/media-release-forms/', { params: { person_id: personId, page, size } })
    return data
  },

  get: async (id: number): Promise<MRFItem> => {
    const { data } = await apiClient.get(`/media-release-forms/${id}`)
    return data
  },

  create: async (
    personId: number,
    payload: {
      event_title?: string
      event_date?: string
      file?: File
    }
  ): Promise<MRFItem> => {
    const formData = new FormData()
    formData.append('person_id', personId.toString())
    if (payload.event_title) formData.append('event_title', payload.event_title)
    if (payload.event_date) formData.append('event_date', payload.event_date)
    if (payload.file) formData.append('file', payload.file)
    
    const { data } = await apiClient.post('/media-release-forms/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  },

  update: async (
    id: number,
    payload: {
      event_title?: string
      event_date?: string
      file?: File
    }
  ): Promise<{ message: string; success: boolean }> => {
    const formData = new FormData()
    if (payload.event_title) formData.append('event_title', payload.event_title)
    if (payload.event_date) formData.append('event_date', payload.event_date)
    if (payload.file) formData.append('file', payload.file)
    
    const { data } = await apiClient.put(`/media-release-forms/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  },

  remove: async (id: number): Promise<{ message: string; success: boolean }> => {
    const { data } = await apiClient.delete(`/media-release-forms/${id}`)
    return data
  },
}


